import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  HotSearchTranslationInput,
  LanguageCodeEnum
} from "../../types/globalTypes";
import TranslationsHotWordPage, {
  fieldNames
} from "../components/TranslationsHotWordPage";
import { TypedUpdateHotWordTranslations } from "../mutations";
import { TypedHotWordTranslationDetails } from "../queries";
import { UpdateHotWordTranslations } from "../types/UpdateHotWordTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsHotWordQueryParams {
  activeField: string;
}
export interface TranslationsHotWordProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsHotWordQueryParams;
}

const TranslationsHotWord: React.FC<TranslationsHotWordProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateHotWordTranslations) => {
    if (data.hotsearchTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedHotWordTranslationDetails variables={{ id, language: languageCode }}>
      {pageHeaderTranslations => (
        <TypedUpdateHotWordTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: HotSearchTranslationInput = {};
              if (field === fieldNames.hotWord) {
                input.hotWord = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsHotWordPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.hotWord, id)
                  )
                }
                onSubmit={handleSubmit}
                hotWord={maybe(() => pageHeaderTranslations.data.hotWord)}
              />
            );
          }}
        </TypedUpdateHotWordTranslations>
      )}
    </TypedHotWordTranslationDetails>
  );
};
TranslationsHotWord.displayName = "TranslationsHotWord";
export default TranslationsHotWord;
